import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';
import '../fonts.css';
import API_BASE_URL from '../api';

// Age Info Form
const AgeInfo = () => {
  const [ageInfo, setAgeInfo] = useState({
    age: '',
    min_age_range: '',
    max_age_range: '',
    willing_to_match_outside_range: '',
  });

  const [message, setMessage] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const getAuthToken = () => localStorage.getItem('stack_access_token');
  const navigate = useNavigate(); // React Router's navigation function

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/age-info`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (response.status === 404) {
          setIsNewUser(true);
          setMessage('No age info found. Please set your age info.');
          return;
        }
        if (!response.ok) {
          throw new Error('Failed to fetch age info');
        }
        return response.json();
      })
      .then((data) => {
        console.log('Received Age Info Data:', data); // DEBUGGING

        if (data) {
          const ageData = {
            age:
              data.find((item) => item.question_text === 'What is your age?')
                ?.answer_int || '',
            min_age_range:
              data.find(
                (item) =>
                  item.question_text ===
                  'What minimum age are you looking for?',
              )?.answer_int || '',
            max_age_range:
              data.find(
                (item) =>
                  item.question_text ===
                  'What maximum age are you looking for?',
              )?.answer_int || '',
            willing_to_match_outside_range:
              data.find(
                (item) =>
                  item.question_text ===
                  'Would you be willing to match with someone outside of that range?',
              )?.answer_text || '',
          };

          console.log('Parsed Age Info:', ageData); // DEBUGGING
          setAgeInfo(ageData);
        }
      })
      .catch((error) => {
        console.error('Error fetching age info:', error);
        setMessage('Error fetching age info.');
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getAuthToken();
    const payload = {
      age: parseInt(ageInfo.age, 10),
      min_age_range: parseInt(ageInfo.min_age_range, 10),
      max_age_range: parseInt(ageInfo.max_age_range, 10),
      willing_to_match_outside_range: ageInfo.willing_to_match_outside_range,
    };

    console.log('Sending Age Info Payload:', payload); // Log the request data

    const method = isNewUser ? 'POST' : 'PUT';

    try {
      const response = await fetch(`${API_BASE_URL}/api/age-info`, {
        method: method,
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();
      console.log('Server Response:', responseData); // Log the response data

      if (!response.ok) {
        throw new Error('Failed to update age info');
      }

      setAgeInfo(payload);
      setMessage('Age info updated successfully.');

      setTimeout(() => {
        navigate('/location-info');
      }, 2000);

      setIsNewUser(false);
    } catch (error) {
      console.error('Error setting age info:', error);
      setMessage('Failed to update age info.');
    }
  };

  const handleChange = (e) => {
    setAgeInfo({
      ...ageInfo,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 flex justify-center items-center">
        <div
          className="w-full max-w-md p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1
            className="text-4xl font-bold text-white text-center mb-6"
            style={{ fontFamily: 'Inter', textTransform: 'uppercase' }}
          >
            Age Info
          </h1>

          {/* Error or Success Message */}
          {message && (
            <p className="text-sm text-green-200 text-center mb-4">{message}</p>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="text-white">
              <label className="block text-sm font-medium">
                What is your age?
                <input
                  type="number"
                  name="age"
                  value={ageInfo.age || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                  required
                />
              </label>
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                What minimum age are you looking for?
                <input
                  type="number"
                  name="min_age_range"
                  value={ageInfo.min_age_range || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                  required
                />
              </label>
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                What maximum age are you looking for?
                <input
                  type="number"
                  name="max_age_range"
                  value={ageInfo.max_age_range || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                  required
                />
              </label>
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                Would you be willing to match with someone outside of that
                range?
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="willing_to_match_outside_range"
                    value="No"
                    checked={ageInfo.willing_to_match_outside_range === 'No'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">No</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="willing_to_match_outside_range"
                    value="Maybe"
                    checked={ageInfo.willing_to_match_outside_range === 'Maybe'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Maybe</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="willing_to_match_outside_range"
                    value="Yes"
                    checked={ageInfo.willing_to_match_outside_range === 'Yes'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Yes</span>
                </label>
              </div>
            </div>

            {/* Next Button */}
            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Next
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AgeInfo;
